import { useCallback } from 'react';
import { useRecordSelection } from "./useRecordSelection.js";
/**
 * Hook to Unselect the rows of a datagrid
 *
 * @example
 *
 * const unselect = useUnselect('posts');
 * unselect([123, 456]);
 */
export var useUnselect = function (resource, storeKey) {
    var _a = useRecordSelection(resource
        ? { resource: resource, storeKey: storeKey }
        : { disableSyncWithStore: true, storeKey: storeKey }), unselect = _a[1].unselect;
    return useCallback(function (ids, fromAllStoreKeys) {
        if (fromAllStoreKeys === void 0) { fromAllStoreKeys = false; }
        unselect(ids, fromAllStoreKeys);
    }, [unselect]);
};
//# sourceMappingURL=useUnselect.js.map